import { apiClient } from "./client";

// Audit-only — see backend_v2/api/view_as.py. The actual impersonation is
// the X-View-As-User-Id header (utils/viewAs.js), attached by apiClient to
// every request; these two calls exist only to leave a clean "who viewed as
// whom, and when they stopped" trail, and to fail fast with a clear message
// before the picker closes.

export async function startViewAsRequest(userId) {
  const res = await apiClient("post", "/view-as/start", { user_id: userId });
  return res.data;
}

// ⚠️ Takes the target id explicitly rather than relying on the (still
// header-swapped) current identity — see the module docstring in
// backend_v2/api/view_as.py for why: calling this WHILE the View-As header is
// still attached would hit the read-only gate (a POST is never a safe
// method), so context/AuthContext.js calls it AFTER clearing the header.
export async function stopViewAsRequest(targetUserId) {
  const res = await apiClient("post", "/view-as/stop", { target_user_id: targetUserId });
  return res.data;
}
